import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mobileflex" }
const _hoisted_2 = { class: "important" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "chartcontainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_RepoList = _resolveComponent("RepoList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleIgnore && _ctx.toggleIgnore(...args))),
        disabled: _ctx.blocked
      }, _toDisplayString(_ctx.ignore ? 'Pokaż języki pomocnicze' : 'Ignoruj języki pomocnicze'), 9, _hoisted_3),
      _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Chart, { langs: _ctx.filteredLangs }, null, 8, ["langs"])
    ]),
    (Object.keys(_ctx.repolangs).length > 1)
      ? (_openBlock(), _createBlock(_component_RepoList, {
          key: 0,
          repositories: _ctx.repositories,
          langs: _ctx.repolangs
        }, null, 8, ["repositories", "langs"]))
      : _createCommentVNode("", true)
  ]))
}